import moment from 'moment';

export default class ItemProjeto {
  constructor(
    IdProjeto = null,
    IdItem = null,
    Item = '',
    Classificacao = '',
    IdTipo = 1, // 1 Grupo 2 Item
    Tipo = 'GRUPO',
    PrevisaoInicial = moment.utc().toISOString(),
    PrevisaoFinal = moment.utc().toISOString(),
    Status = 'A',
    IdPrioridade = 1,
    Prioridade = 'NORMAL',
    IdSituacao = 44,
    Situacao = 'INICIO',
    DuracaoPrevista = new Date(1970, 0, 1, 0, 0, 0),
  ) {
    this.IdProjeto = IdProjeto;
    this.IdItem = IdItem;
    this.Item = Item;
    this.Classificacao = Classificacao;
    this.IdTipo = IdTipo;
    this.Tipo = Tipo;
    this.PrevisaoInicial = PrevisaoInicial;
    this.PrevisaoFinal = PrevisaoFinal;
    this.Status = Status;
    this.IdPrioridade = IdPrioridade;
    this.Prioridade = Prioridade;
    this.IdSituacao = IdSituacao;
    this.Situacao = Situacao;
    this.DuracaoPrevista = DuracaoPrevista;
  }
}